import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { map, tap } from "rxjs/operators";
@Injectable({
  providedIn: "root",
})
export class DataSharingService {
  private assetDetailsData = new BehaviorSubject({});
  assetDetailsData$ = this.assetDetailsData.asObservable();

  private filterDataOption = new BehaviorSubject([]);
  filterDataOption$ = this.filterDataOption.asObservable();

  locationPreference = new BehaviorSubject(null);
  locationPreference$ = this.locationPreference.asObservable();

  private selectedColumnFilters = new BehaviorSubject({
    list: [],
    columnId: null,
    filterData: [],
  });
  selectedColumnFilters$ = this.selectedColumnFilters.asObservable();

  private legend = new BehaviorSubject({});
  legend$ = this.legend.asObservable();

  private showRiwskAssesment = new BehaviorSubject(false);
  showRiwskAssesment$ = this.showRiwskAssesment.asObservable();

  // private additionalInfoData = new BehaviorSubject(
  //   new AdditionalInfoAndExemptionsPostData()
  // );
  // additionalInfoData$ = this.additionalInfoData.asObservable();

  filtersWithCheckedValues$ = this.selectedColumnFilters$.pipe(
    tap((data) => console.log("filter data before piping", data)),
    map((data) => {
      const i = data.filterData.findIndex(
        (item) => item.columnId === data.columnId
      );
      const filterValues =
        i > -1 ? data.filterData[i].filterValues.split(",") : [];
      return data.list.map((filterTerm) => ({
        name: filterTerm,
        isSelected: filterValues.includes(filterTerm),
      }));
    }),
    tap((data) => console.log("data with checked values", data))
  );

  constructor() {}

  shareAssetData(assetData: any) {
    this.assetDetailsData.next(assetData);
  }

  shareFilterColumnData(filterData) {
    console.log("data", filterData);
    this.filterDataOption.next(filterData);
  }

  shareLegendData(filterData: any) {
    this.legend.next(filterData);
  }

  shareFilterList(list) {
    this.selectedColumnFilters.next(list);
  }

  // shareAdditionalInfoData(data: any): void {
  //   this.additionalInfoData.next(data);
  // }

  shareRiskassesmentView(data: any): void {
    this.showRiwskAssesment.next(data);
  }
}
